import React from 'react'
import { useRouter, useHandler, ModalContext, Form } from 'labguard-cdk'
import { validateLogin } from 'src/services/auth'
import { AccountContext } from 'src/contexts'
import { ChangePasswordModal } from 'src/components/common'
import LoginForm from './LoginForm'

export default function LoginFormContainer() {
  const { login, refetch, account } = AccountContext.use()
  const { open } = ModalContext.use()

  const {
    location: { state },
    history: { push },
  } = useRouter()

  // refetch account on mount (in case of forced redirection)
  React.useEffect(() => {
    refetch()
  }, [refetch])

  // redirect if user is logged in
  React.useEffect(() => {
    if (account.id && account.id !== '-1') push((state && state.from) || { pathname: '/' })
  }, [account, push, state])

  const onSubmit = useHandler(values =>
    login({ variables: values })
      // handle errors
      .catch(error => {
        error.graphQLErrors &&
          error.graphQLErrors.forEach(({ extensions = {} }) => {
            switch (extensions.code) {
              case 'EXPIRED_PASSWORD': {
                open(<ChangePasswordModal providePassword provideUsername user={values} />)
                break
              }
              default:
                break
            }
          })
        throw error
      })
  )

  const initialValues = React.useMemo(
    () => ({
      username: '',
      password: '',
    }),
    []
  )

  return (
    <Form onSubmit={onSubmit} validate={validateLogin} initialValues={initialValues}>
      <LoginForm />
    </Form>
  )
}
